import { CurrencyCodeIso, getCurrencySymbol } from "../constants/currency";

export function formatCurrency(
	value?: number | null,
	currency: CurrencyCodeIso = CurrencyCodeIso.EUR
) {
	if (typeof value !== "number") {
		return "-";
	}
	return `${value.toFixed(2)} ${getCurrencySymbol(currency)}`;
}
